import React, { useEffect, useState } from "react";
import { blockClassMap, classGroups } from "./class-config/classGroups";
import ColorSwatchSelector from "./Selector/ColorSwatchSelector";
import "./ClassSelectorLayout.css";
import SimpleOptionSelector from "./Selector/SimpleOptionSelector";
import MaterialIcon from "../BuilderComponents/MaterialIcon";
import ButtonOptionSelector from "./Selector/ButtonOptionSelector";
import FontSizeSelector from "./Selector/FontSizeSelector";

const convertArrayToSelectedObject = (defaultSelectedArray) => {
  const selectedObj = {};
  Object.entries(classGroups).forEach(([groupKey, group]) => {
    const allClasses = Object.values(group.options)
      .flat()
      .map((opt) => opt.class);
    const matched = defaultSelectedArray.find((cls) => allClasses.includes(cls));
    if (matched) selectedObj[groupKey] = matched;
  });
  return selectedObj;
};

const convertSelectedObjectToArray = (selectedObj) => {
  return Object.values(selectedObj).filter(Boolean);
};

export default function ClassSelectorLayout({ id, type, defaultSelected = [], onChange }) {
  const groupKeys = blockClassMap[type] || blockClassMap["default"];
  const [selected, setSelected] = useState({});

  useEffect(() => {
    setSelected(convertArrayToSelectedObject(defaultSelected));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleGroupChange = (groupKey, newClass) => {
    const updated = {
      ...selected,
      [groupKey]: newClass === selected[groupKey] ? "" : newClass
    };
    setSelected(updated);
    if (onChange) onChange(convertSelectedObjectToArray(updated));
  };
  return (
    <div
      // style={{
      //   padding: 16,
      //   width: 386,
      //   margin: "0 auto",
      //   display: "flex",
      //   flexDirection: "column",
      //   gap: 16,
      //   fontFamily: "Inter, sans-serif"
      // }}
      className="form_basic_field_wrapper sidebar-edit-option-outer"
    >
      {/* Color Swatch Groups */}
      {groupKeys.includes("bg_color") && classGroups.bg_color && (
        <ColorSwatchSelector
          group={classGroups.bg_color}
          selectedClass={selected.bg_color || ""}
          onChange={(newClass) => handleGroupChange("bg_color", newClass)}
          gridColumns={8}
        />
      )}
      {groupKeys.includes("text_color") && classGroups.text_color && (
        <ColorSwatchSelector
          group={classGroups.text_color}
          selectedClass={selected.text_color || ""}
          onChange={(newClass) => handleGroupChange("text_color", newClass)}
          gridColumns={8}
        />
      )}

      <FontSizeSelector
        selected={selected}
        classGroups={classGroups}
        handleGroupChange={handleGroupChange}
        groupKeys={groupKeys}
      />

      {groupKeys.includes("text_weight") && classGroups.text_weight && (
        <SimpleOptionSelector
          label={classGroups.text_weight.label}
          options={classGroups.text_weight.options.default}
          selectedClass={selected.text_weight || ""}
          onChange={(newClass) => handleGroupChange("text_weight", newClass)}
          renderLabel={(cls) => {
            switch (cls) {
              case "z-font-weight-light":
                return "Light";
              case "z-font-weight-regular":
                return "Reg";
              case "z-font-weight-medium":
                return "Med";
              case "z-font-weight-semibold":
                return "Semi";
              case "z-font-weight-bold":
                return "Bold";
              default:
                return "N/A";
            }
          }}
        />
      )}

      {groupKeys.includes("text_decoration") && classGroups.text_decoration && (
        <SimpleOptionSelector
          label={classGroups.text_decoration.label}
          options={classGroups.text_decoration.options.default}
          selectedClass={selected.text_decoration || ""}
          onChange={(newClass) => handleGroupChange("text_decoration", newClass)}
          renderLabel={(cls) => {
            if (cls.includes("no")) return "NO";
            if (cls.includes("underline")) return "UN";
            if (cls.includes("overline")) return "OV";
            if (cls.includes("line-through")) return "LT";
            return "TX";
          }}
        />
      )}

      {(groupKeys.includes("text_align_horizontal") || groupKeys.includes("text_align_vertical")) && (
        <div className={"d_flex gap_3"}>
          {groupKeys.includes("text_align_horizontal") && classGroups.text_align_horizontal && (
            <SimpleOptionSelector
              label={classGroups.text_align_horizontal.label}
              options={classGroups.text_align_horizontal.options.default}
              selectedClass={selected.text_align_horizontal || ""}
              onChange={(newClass) => handleGroupChange("text_align_horizontal", newClass)}
              renderLabel={(cls) => {
                if (cls.includes("left"))
                  return <MaterialIcon name="format_align_left" type="rounded" style={{ fontSize: 20 }} />;
                if (cls.includes("center"))
                  return <MaterialIcon name="format_align_center" type="rounded" style={{ fontSize: 20 }} />;
                if (cls.includes("right"))
                  return <MaterialIcon name="format_align_right" type="rounded" style={{ fontSize: 20 }} />;
                return "?";
              }}
              boxStyle={{ height: 40 }}
            />
          )}

          {groupKeys.includes("text_align_vertical") && classGroups.text_align_vertical && (
            <SimpleOptionSelector
              label={classGroups.text_align_vertical.label}
              options={classGroups.text_align_vertical.options.default}
              selectedClass={selected.text_align_vertical || ""}
              onChange={(newClass) => handleGroupChange("text_align_vertical", newClass)}
              renderLabel={(cls) => {
                if (cls.includes("top"))
                  return <MaterialIcon name="vertical_align_top" type="rounded" style={{ fontSize: 20 }} />;
                if (cls.includes("center"))
                  return <MaterialIcon name="vertical_align_center" type="rounded" style={{ fontSize: 20 }} />;
                if (cls.includes("bottom"))
                  return <MaterialIcon name="vertical_align_bottom" type="rounded" style={{ fontSize: 20 }} />;
                return "?";
              }}
              boxStyle={{ height: 40 }}
            />
          )}
        </div>
      )}

      {(groupKeys.includes("icon_style") || groupKeys.includes("icon_fill")) && (
        <div style={{ display: "flex", gap: 12, width: "100%" }}>
          {groupKeys.includes("icon_style") && classGroups.icon_style && (
            <div style={{ flex: 3 }}>
              <SimpleOptionSelector
                label={classGroups.icon_style.label}
                options={classGroups.icon_style.options.default}
                selectedClass={selected.icon_style || ""}
                onChange={(newClass) => handleGroupChange("icon_style", newClass)}
                renderLabel={(cls) => {
                  if (cls.includes("outlined")) return "Outlined";
                  if (cls.includes("rounded")) return "Rounded";
                  if (cls.includes("sharp")) return "Sharp";
                  return "Standard";
                }}
              />
            </div>
          )}

          {groupKeys.includes("icon_fill") && classGroups.icon_fill && (
            <div style={{ flex: 1 }}>
              <SimpleOptionSelector
                label={classGroups.icon_fill.label}
                options={classGroups.icon_fill.options.default}
                selectedClass={selected.icon_fill || ""}
                onChange={(newClass) => handleGroupChange("icon_fill", newClass)}
                renderLabel={() => "FILL"}
              />
            </div>
          )}
        </div>
      )}

      {groupKeys.includes("icon_size") && classGroups.icon_size && (
        <SimpleOptionSelector
          label={classGroups.icon_size.label}
          options={classGroups.icon_size.options.default}
          selectedClass={selected.icon_size || ""}
          onChange={(newClass) => handleGroupChange("icon_size", newClass)}
          renderLabel={(cls) => <MaterialIcon name="home" className={cls} />}
        />
      )}

      {groupKeys.includes("icon_weight") && classGroups.icon_weight && (
        <SimpleOptionSelector
          label={classGroups.icon_weight.label}
          options={classGroups.icon_weight.options.default}
          selectedClass={selected.icon_weight || ""}
          onChange={(newClass) => handleGroupChange("icon_weight", newClass)}
          renderLabel={(cls) => {
            const weight = cls.match(/\d+/)?.[0];
            return <MaterialIcon name="home" className={cls} style={{ fontWeight: weight }} />;
          }}
        />
      )}

      {groupKeys.includes("border_color") && classGroups.border_color && (
        <ColorSwatchSelector
          group={classGroups.border_color}
          selectedClass={selected.border_color || ""}
          onChange={(newClass) => handleGroupChange("border_color", newClass)}
          gridColumns={8}
        />
      )}

      {groupKeys.includes("border_style") && classGroups.border_style && (
        <SimpleOptionSelector
          label={classGroups.border_style.label}
          options={classGroups.border_style.options.default}
          selectedClass={selected.border_style || ""}
          onChange={(newClass) => handleGroupChange("border_style", newClass)}
          renderLabel={renderBorderStyleLabel}
        />
      )}

      {groupKeys.includes("border_size") && classGroups.border_size && (
        <SimpleOptionSelector
          label={classGroups.border_size.label}
          options={classGroups.border_size.options.default}
          selectedClass={selected.border_size || ""}
          onChange={(newClass) => handleGroupChange("border_size", newClass)}
          renderLabel={renderBorderSizeLabel}
        />
      )}

      {groupKeys.includes("border_radius") && classGroups.border_radius && (
        <SimpleOptionSelector
          label={classGroups.border_radius.label}
          options={classGroups.border_radius.options.default}
          selectedClass={selected.border_radius || ""}
          onChange={(newClass) => handleGroupChange("border_radius", newClass)}
          renderLabel={renderBorderRadiusLabel}
        />
      )}
      {groupKeys.includes("padding") && classGroups.padding && (
        <SimpleOptionSelector
          label={classGroups.padding.label}
          options={classGroups.padding.options.default}
          selectedClass={selected.padding || ""}
          onChange={(newClass) => handleGroupChange("padding", newClass)}
          renderLabel={(cls) =>
            ({
              "z-p-1": "XS",
              "z-p-2": "SM",
              "z-p-3": "MD",
              "z-p-4": "LG",
              "z-p-5": "XL"
            })[cls] || "PD"
          }
          applyClass={false}
        />
      )}

      {groupKeys.includes("button") && classGroups.button && (
        <ButtonOptionSelector
          label={classGroups.button.label}
          options={classGroups.button.options.default}
          selectedClass={selected.button || ""}
          onChange={(newClass) => handleGroupChange("button", newClass)}
          columns={2}
          buttonStyle={{
            width: "100%"
          }}
        />
      )}

      {groupKeys.includes("button_circle") && classGroups.button_circle && (
        <ButtonOptionSelector
          label={classGroups.button_circle.label}
          options={classGroups.button_circle.options.default}
          selectedClass={selected.button_circle || ""}
          onChange={(newClass) => handleGroupChange("button_circle", newClass)}
          columns={3}
        />
      )}

      {groupKeys.includes("button_size") && classGroups.button_size && (
        <ButtonOptionSelector
          label={classGroups.button_size.label}
          options={classGroups.button_size.options.default}
          selectedClass={selected.button_size || ""}
          onChange={(newClass) => handleGroupChange("button_size", newClass)}
          buttonStyle={{
            width: "100%"
          }}
        />
      )}

      {groupKeys.includes("image_object_fit") && classGroups.image_object_fit && (
        <SimpleOptionSelector
          label={classGroups.image_object_fit.label}
          options={classGroups.image_object_fit.options.default}
          selectedClass={selected.image_object_fit || ""}
          onChange={(newClass) => handleGroupChange("image_object_fit", newClass)}
          renderLabel={(cls) => {
            const text = cls.split("-").pop();
            return text[0].toUpperCase() + text.slice(1);
          }}
        />
      )}

      {groupKeys.includes("shadow") && classGroups.shadow && (
        <SimpleOptionSelector
          label={classGroups.shadow.label}
          options={classGroups.shadow.options.default}
          selectedClass={selected.shadow || ""}
          onChange={(newClass) => handleGroupChange("shadow", newClass)}
          renderLabel={(cls) => {
            const label = cls.split("-").pop();
            return label === "none" ? "NO" : label.toUpperCase();
          }}
        />
      )}

      {groupKeys.includes("table_style") && classGroups.table_style && (
        <SimpleOptionSelector
          label={classGroups.table_style.label}
          options={classGroups.table_style.options.default}
          selectedClass={selected.table_style || ""}
          onChange={(newClass) => handleGroupChange("table_style", newClass)}
          renderLabel={(cls) => {
            if (cls.includes("bordered")) return "Bordered";
            if (cls.includes("transparent")) return "Borderless";
            if (cls.includes("stripped")) return "Stripped";
            return "Table";
          }}
        />
      )}

      {groupKeys.includes("search_box") && classGroups.search_box && (
        <SimpleOptionSelector
          label={classGroups.search_box.label}
          options={classGroups.search_box.options.default}
          selectedClass={selected.search_box || ""}
          onChange={(newClass) => handleGroupChange("search_box", newClass)}
          renderLabel={(cls) => {
            if (cls.includes("small")) return "Small";
            if (cls.includes("medium")) return "Medium";
            if (cls.includes("large")) return "Large";
            return "Search";
          }}
          applyClass={false}
        />
      )}
    </div>
  );
}

const renderBorderStyleLabel = (cls) => {
  const styleMap = {
    solid: "solid",
    dotted: "dotted",
    dashed: "dashed",
    double: "double"
  };
  const borderStyle = Object.entries(styleMap).find(([key]) => cls.includes(key))?.[1] || "solid";

  return (
    <div
      title={cls}
      style={{
        width: 48,
        height: 8,
        borderBottomStyle: borderStyle,
        borderBottomWidth: 3,
        borderBottomColor: "#4B5563", // neutral gray-700
        borderRadius: borderStyle === "double" ? 0 : 2,
        margin: "0 auto",
        boxSizing: "border-box"
      }}
    />
  );
};

const renderBorderSizeLabel = (cls) => {
  const sizeMap = {
    sm: 1,
    md: 2,
    lg: 4
  };
  const borderWidth = Object.entries(sizeMap).find(([key]) => cls.includes(key))?.[1] || 1;

  return (
    <hr
      style={{
        border: "none",
        borderBottomWidth: borderWidth,
        borderBottomStyle: "solid",
        borderBottomColor: "#374151", // gray-800
        width: 48,
        margin: "0 auto",
        borderRadius: 2
      }}
      title={cls}
    />
  );
};

const renderBorderRadiusLabel = (cls) => {
  const radiusMap = {
    none: 0,
    sm: 2,
    md: 4,
    lg: 8,
    pill: 999, // capsule
    full: 9999 // circle
  };

  const [key, radius] = Object.entries(radiusMap).find(([key]) => cls.includes(key)) || [];

  let width = 36;
  let height = 24;

  if (key === "pill") {
    width = 32;
    height = 20;
  }

  if (key === "full") {
    width = 28;
    height = 28;
  }

  return (
    <div
      title={cls}
      style={{
        width,
        height,
        borderRadius: radius,
        backgroundColor: "#F3F4F6", // soft gray
        border: "1px solid #D1D5DB", // border-gray-300
        boxShadow: "inset 0 0 1px rgba(0,0,0,0.08)",
        margin: "8px auto",
        transition: "all 0.2s ease"
      }}
    />
  );
};
